import { Work } from '../types/work';
import BaseEntityService from './baseEntityService';

const serviceUrlSuffix = 'v1/works'

class WorkService extends BaseEntityService<Work> {
    constructor() {
        super(serviceUrlSuffix);
    }
}

export const workService = new WorkService();